import { useGetImageDownloadUrl } from '#pplx/frontend/apps/ask/hooks/file-search-hooks/useGetImageDownloadUrl.js';
import { createMediaFileFromUrl } from '#pplx/frontend/components/hooks/mediaFileUrlIngress.js';
import { useCallback } from 'react';
/** Preserves the Ask input's private-image URL resolution policy. */
export function useMediaImageUrlResolver({ backendUUID, reason, }) {
    const { getCachedImageDownloadUrl, getImageDownloadUrl } = useGetImageDownloadUrl({ reason });
    return useCallback(async (privateUrl) => {
        if (!backendUUID)
            return getCachedImageDownloadUrl(privateUrl);
        return getImageDownloadUrl({ url: privateUrl, thread_id: backendUUID });
    }, [backendUUID, getCachedImageDownloadUrl, getImageDownloadUrl]);
}
/** Preserves the Ask input's URL-to-local-file ingress for attachment surfaces. */
export function useMediaFileUrlIngress({ addFile, getImageUrl, }) {
    return useCallback(async (source) => {
        const { filename, mimeType, url } = source;
        const file = await createMediaFileFromUrl({ filename, getImageUrl, mimeType, url });
        if (file)
            addFile(file, source);
    }, [addFile, getImageUrl]);
}
//# sourceMappingURL=useMediaFileUrlIngress.js.map